module.exports = __webpack_public_path__ + "static/media/calendario-hombre-centro.518e072a.png";